import {call, put, select, take, takeEvery, takeLeading} from 'redux-saga/effects'

import {
  categoryDisplayNames,
  LookbuilderViews,
  removalOrigins,
  tagsByCategory,
} from '../../store/lookbuilder/enums'
import * as lookbuilderActions from '../../actions/lookbuilder'
import * as lookbuilderSelectors from '../../store/lookbuilder'
import * as userInteractionActions from '../../actions/userInteractions'
import {normalizeProductsByCategory} from './helpers'
import * as track from '../../track/category'

import {getProductsByTags} from '../../api/product'
import {isBadResponse} from '../../api/statusCodes'

/**
 * Handles fetching of data for populating each Category View.
 *
 * @param {Object} payload
 * @param {String} payload.category The lookbuilder category slug
 */
export function* openCategoryViewWorker({payload: {category}}) {
  yield put(lookbuilderActions.navigateToView(LookbuilderViews.category))
  yield call(track.viewedProductCategory, categoryDisplayNames[category])

  const previousStep = yield select(lookbuilderSelectors.previousStep)
  const previousCategory = yield select(lookbuilderSelectors.previousCategory)
  if (previousStep === LookbuilderViews.detail || previousCategory === category) {
    return
  }

  yield put(lookbuilderActions.getProductsByCategoryPending())
  try {
    const sortQueryParam = 'display_position'
    const tagsQueryParam = tagsByCategory[category].join('OR')
    const {json, status} = yield call(getProductsByTags, {sortQueryParam, tagsQueryParam})

    if (isBadResponse(status)) {
      throw new Error()
    }

    yield put(
      lookbuilderActions.getProductsByCategorySuccess(normalizeProductsByCategory(json.results)),
    )
  } catch {
    yield put(lookbuilderActions.getProductsByCategoryFailure())
  }
}

export function* openCategoryViewSaga() {
  yield takeLeading(lookbuilderActions.OPEN_LOOKBUILDER_CATEGORY_VIEW, openCategoryViewWorker)
}

/**
 * Handles error action dispatched when fetching products fails.
 */
export function* handleGetProductsByCategoryErrorWorker() {
  yield call(window.alert, 'We encountered an error. Please try again.')
}

export function* handleGetProductsByCategoryErrorSaga() {
  yield takeEvery(
    lookbuilderActions.GET_PRODUCTS_BY_CATEGORY_FAILURE,
    handleGetProductsByCategoryErrorWorker,
  )
}

/**
 * Handles removing an item from the lookbuilder
 *
 * @param {Object} payload
 * @param {String} payload.category The lookbuilder category slug
 * @param {String} payload.origin The location within lookbuilder
 */
export function* removeFromLookbuilderLookWorker({payload: {category, origin}}) {
  switch (origin) {
    case removalOrigins.RENT_BUY:
      yield put(userInteractionActions.openLookbuilderRemoveItemModal())
      yield take(lookbuilderActions.CONFIRM_REMOVE_FROM_LOOKBUILDER_LOOK)
      yield put(lookbuilderActions.updatePlannerCategory(category, {}))
      yield put(userInteractionActions.closeModal())
      break
    default:
      yield put(lookbuilderActions.updatePlannerCategory(category, {}))
      yield put(lookbuilderActions.navigateToView(LookbuilderViews.planner))
      break
  }
}

export function* removeFromLookbuilderLookSaga() {
  yield takeEvery(lookbuilderActions.REMOVE_FROM_LOOKBUILDER_LOOK, removeFromLookbuilderLookWorker)
}
